import { Routes, Route } from "react-router-dom";

import VacancySection from "./sections/vacancyListSection";
import ApplicationFormSection from "./sections/applicationformListSection";
import VacantroutesSection from "./sections/vacantroutesListSection";
import VacancySingleSection from "./sections/vacancySingleSection";
import ApplicationFormSingleSection from "./sections/applicationformSingleSection";
import ApplicationFormCreateSection from "./sections/applicationformCreateSection";

function RecruitingApp() {
    const data = JSON.parse(localStorage.getItem("userData") as string);

    return (
        <Routes>
            {!data.isCustomer && (
                <>
                    <Route path="/vacancy" element={<VacancySection />} />
                    <Route path="/vacancy/:id" element={<VacancySingleSection />} />
                    <Route path="/applicationform" element={<ApplicationFormSection />} />
                    <Route path="/applicationform/create" element={<ApplicationFormCreateSection />} />
                    <Route path="/applicationform/:id" element={<ApplicationFormSingleSection />} />
                    <Route path="/vacantroutes" element={<VacantroutesSection />} />
                </>
            )}
        </Routes>
    );
}

export default RecruitingApp;
